import { SortDescriptor } from "@progress/kendo-data-query";

export const DEFAULT_SORTING: SortDescriptor = {
  field: 'timestamp',
  dir: 'desc'
};